module.exports = __webpack_public_path__ + "static/media/conversations-icon.ac2317fa.svg";